export const OneOneInquiryDetailPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">1:1문의 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th colSpan={2} style={{ width: "12.5%" }}>제목</th>
                                <td>오프라인 전화 인증은 어떻게 하나요?</td>
                            </tr>
                            <tr>
                                <th colSpan={2}>작성자/등록일</th>
                                <td>김철수 | 2024-00-00</td>
                            </tr>
                            <tr>
                                <th rowSpan={4}>기본정보</th>
                                <th style={{ width: "6.5%" }}>유형</th>
                                <td>설치</td>
                            </tr>
                            <tr>
                                <th>벤더</th>
                                <td>MS</td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td>Win11</td>
                            </tr>
                            <tr>
                                <th>상태</th>
                                <td>
                                    <select className="form-select text-success w-150px">
                                        <option>진행</option>
                                    </select>
                                </td>
                            </tr>
                            <tr style={{ height: "249px" }}>
                                <th colSpan={2}>내용</th>
                                <td style={{ verticalAlign: "top" }}>오프라인 전화 인증은 어떻게 하나요? 오프라인 전화 인증은 어떻게 하나요?오프라인 전화 인증은 어떻게 하나요?오프라인 전화 인증은 어떻게 나요?오프라인 전화 인증은 어떻게 하나요? 오프라인 전화 인증은 어떻게 하나요?오프라인 전화 인증은 어떻게 하나요?</td>
                            </tr>
                            <tr>
                                <th colSpan={2}>첨부파일</th>
                                <td>
                                    <div className="tbl_files_outer">
                                        <ul className="list_files">
                                            <li>
                                                <a href="#/file-1">첨부파일1.pdf</a>
                                            </li>
                                            <li>
                                                <a href="#/file-1">첨부파일2.pdf</a>
                                            </li>
                                            <li>
                                                <a href="#/file-1">첨부파일3.pdf</a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h3 className="comment_heading">답변</h3>

                <div className="comment_item">
                    <div className="comment_top">
                        <div>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_user_comment.png"} alt="" />
                        </div>
                        <div>
                            김철수<br />
                            2024-00-00
                        </div>
                    </div>
                    <div className="comment_detail">
                        <div className="message">이러이러한 것이 안 됩니다만</div>
                        <div className="btn_list_files">
                            <button className="btn btn-outline-secondary">첨부파일1.pdf <img src={process.env.PUBLIC_URL + "/assets/images/icon_comment_download.png"} alt="" /></button>
                        </div>
                    </div>
                </div>

                <div className="comment_item">
                    <div className="comment_top">
                        <div>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_user_comment.png"} alt="" />
                        </div>
                        <div>
                            김철수<br />
                            2024-00-00
                        </div>
                    </div>
                    <div className="comment_detail">
                        <div className="message">이러이러한 것이 안 됩니다만</div>
                    </div>
                </div>
            </div>
        </>
    );
}